import {debounce} from '@utils/debounce';

const regionListItems = document.querySelectorAll('.region-list li');
const regions = {
    stockholm: document.querySelectorAll('svg path.stockholm'),
    syd: document.querySelectorAll('svg path.syd'),
    mitt: document.querySelectorAll('svg path.mitt'),
    vast: document.querySelectorAll('svg path.vast'),
    ost: document.querySelectorAll('svg path.ost'),
    nord: document.querySelectorAll('svg path.nord'),
    bergslagen: document.querySelectorAll('svg path.bergslagen')
};

function isSmallScreen() {
    return window.innerWidth <= 768;
}

function applyFillColor() {
    for (const region in regions) {
        regions[region].forEach(path => {
            if (isSmallScreen()) {
                path.style.fill = getColorForRegion(region);
            } else {
                path.style.fill = '';
            }
        });
    }
}

const debouncedApplyFillColor = debounce(() => {
    applyFillColor();
}, 200);

window.addEventListener('resize', debouncedApplyFillColor);
applyFillColor(); // Initial check

function getColorForRegion(region) {
    const colors = {
        stockholm: '#373CFF',
        syd: '#373CFF',
        mitt: '#78C8FF',
        vast: '#78C8FF',
        ost: '#37A0F0',
        nord: '#373CFF',
        bergslagen: '#37A0F0'
    };
    return colors[region] || '#78C8FF';
}

function applySpecialFillColor() {
    for (const region in regions) {
        regions[region].forEach(path => {
            path.style.fill = '#000596';
        });
    }
}

function resetFillColor() {
    for (const region in regions) {
        regions[region].forEach(path => {
            path.style.fill = '';
        });
    }
}

regionListItems.forEach(item => {
    item.addEventListener('mouseover', () => {
        if (isSmallScreen()) {
            return;
        }

        const dataRegion = item.getAttribute('data-region');
        if (dataRegion) {
            if (dataRegion.includes('nationella-avdelningar') || dataRegion.includes('rikspolisen')) {
                applySpecialFillColor();
            } else {
                const regionIds = dataRegion.split(',');
                regionIds.forEach(regionId => {
                    const trimmedId = regionId.trim();
                    const regionElement = document.getElementById(trimmedId);
                    if (regionElement) {
                        regionElement.classList.add('region--highlight');
                    }
                });
            }
        }
    });

    item.addEventListener('mouseout', () => {
        if (isSmallScreen()) {
            return;
        }

        const dataRegion = item.getAttribute('data-region');
        if (dataRegion) {
            if (dataRegion.includes('nationella-avdelningar') || dataRegion.includes('rikspolisen')) {
                resetFillColor();
            } else {
                const regionIds = dataRegion.split(',');
                regionIds.forEach(regionId => {
                    const trimmedId = regionId.trim();
                    const regionElement = document.getElementById(trimmedId);
                    if (regionElement) {
                        regionElement.classList.remove('region--highlight');
                    }
                });
            }
        }
    });
});

function addRegionEventListeners(regionClass) {
    const regions = document.querySelectorAll(`.region.${regionClass}`);
    regions.forEach(region => {
        region.addEventListener('click', () => {
            if (isSmallScreen()) {
                return;
            }

            const listItem = document.querySelector(`.region-list li[data-region*="${regionClass}"]`);
            if (listItem) {
                listItem.querySelector('a').click();
            }
        });
    });
}

const regionClasses = ['stockholm', 'syd', 'mitt', 'vast', 'ost', 'nord', 'bergslagen'];
regionClasses.forEach(addRegionEventListeners);